const getMenuBarState = state => state.automation.menuBar;
export const getOpenId = state => getMenuBarState(state).openId;
export const getIsActive = state => getMenuBarState(state).isActive;
export const getModalState = state => getMenuBarState(state).modalState;